import { type IEvent } from 'clients/PlatformApi';
import { AppDispatcher } from 'dispatcher';
import * as constants from 'vd-constants';
import { BaseStore } from './BaseStore';

let _pinnedEvent: IEvent | undefined;
let _videoStartTime: number | undefined;
let _source: string | undefined;

const CurrentActiveEventStore = {
  ...BaseStore,
  getPinned: () => _pinnedEvent,

  getVideoStartTime: () => _videoStartTime,

  getSource: () => _source,

  dispatchToken: AppDispatcher.register((action: any) => {
    switch (action.type) {
      case constants.CREATE_EVENT: {
        const { event, switchToEvent } = action;
        if (switchToEvent) {
          _pinnedEvent = event;
          _videoStartTime = undefined;
          CurrentActiveEventStore.emitChange();
        }

        break;
      }

      case constants.PIN_EVENT: {
        const event = action.payload;
        _pinnedEvent = event;

        _videoStartTime = action.videoStartTime;
        _source = action.source;

        CurrentActiveEventStore.emitChange();
        break;
      }

      case constants.CLEAR_ACTIVE_EVENT:
      case constants.CLOSE_EVENT_PLAYER:
      case constants.VISIT_PAGE:
        _pinnedEvent = undefined;
        _source = undefined;
        _videoStartTime = undefined;
        CurrentActiveEventStore.emitChange();
        break;
    }
  }),
};

export default CurrentActiveEventStore;
